import { ComponentPropsWithoutRef } from "react";
import { LeftNavItem } from "@src/straps/base/navigation/LeftNav";

export type BuildingSelectionSubItemProps = Omit<
  ComponentPropsWithoutRef<typeof LeftNavItem>,
  "path"
> & {
  subPath: string;
  siteId: number;
};
export function BuildingSelectionSubItem({
  siteId,
  subPath,
  ...props
}: Readonly<BuildingSelectionSubItemProps>) {
  return <LeftNavItem path={`/site/${siteId}/${subPath}`} {...props} />;
}
